// extracted by css-extract-rspack-plugin
export default {"cls1":"NewCitationPing-cls1_p1T","cls2":"NewCitationPing-cls2_rLM NewCitationPing-cls1_p1T"};